export default __webpack_public_path__ + "static/media/img-2.47239849.jpg";